import { connect } from 'react-redux'

import MaintenanceOrderEditComponent from '../components/MaintenanceOrderEditComponent.jsx';
import { 
	forwardToChangeMaintenanceOrderValue,
	forwardToAddMaintenanceOrder,
	forwardToEditMaintenanceOrder,
	// forwardToFindAllCustomerIds,
	findAllCustomerIds
} from '../actions';

function showNote(roles) {
	// return roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD");
	return true;
}

const mapStateToProps = (state) => ({
	order: state.getIn(['maintenanceOrderReducer', 'order']),
	orderValidation: state.getIn(['maintenanceOrderReducer', 'orderValidation']),
	alertStyle: state.getIn(['maintenanceOrderReducer', 'alertStyle']),
	alertMessage: state.getIn(['maintenanceOrderReducer', 'alertMessage']),
	forInsert: state.getIn(['maintenanceOrderReducer', 'forInsert']),

	activePage: state.getIn(['maintenanceOrderListReducer', 'activePage']),
	itemPerPage: state.getIn(['maintenanceOrderListReducer', 'itemPerPage']),

	showNote: showNote(state.getIn(['authReducer', 'roles']).toJS()),
	
	allCustomerIds: state.getIn(['orderReducer', 'allCustomerIds'])
})

const mapDispatchToProps = (dispatch) => ({
	editOrder: (order, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(forwardToAddMaintenanceOrder(order, pagingData));
		} else {
			dispatch(forwardToEditMaintenanceOrder(order, pagingData));
		}
	},
	setValue: (id, value) => {
		dispatch(forwardToChangeMaintenanceOrderValue({
			id: id,
			value: value
		}))
	},
	findAllCustomerIds: () => {
		dispatch(findAllCustomerIds());
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	order: stateProps.order,
	orderValidation: stateProps.orderValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	forInsert: stateProps.forInsert,
	allCustomerIds: stateProps.allCustomerIds,
	showNote: stateProps.showNote,
	componentDidMount: dispatchProps.componentDidMount,
	editOrder: () => dispatchProps.editOrder(stateProps.order, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}, stateProps.forInsert),
	setValue: dispatchProps.setValue,
	findAllCustomerIds: dispatchProps.findAllCustomerIds
})

const MaintenanceOrderEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(MaintenanceOrderEditComponent)

export default MaintenanceOrderEditContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceOrderEditContainer.jsx